import * as React from "react";
import { ThemeProvider } from 'styled-components';
import { ToolPanel } from "../organisms/ToolPanel";
import { ObjectPanel } from "../organisms/ObjectPanel";
import { WorkArea } from "../organisms/WorkArea";
import { PropertyPanel } from "../organisms/PropertyPanel";
import { tools } from "../../tools";
import { store, state, scene } from "../../store";
import { setTool } from "../../actions/setTool";
import { rerender } from "../../renderer/renderer";
import { Picker } from "../organisms/Picker";
import { Timeline } from "../organisms/Timeline";
import { objectTypes } from "../../renderer/objects";
import { observer } from "mobx-react";
import { PointsTool } from "../../tools/points";
import { styled, theme } from "../../theme";
import { NodeEditor } from "flume";
import config, {doAction, gamelogic} from "../../flume";
import { GameLogicScreen } from "../organisms/GameLogicScreen";

type Tree = { [key: string]: {
    id: string,
    x: number,
    y: number,
    type: string,
    width: number,
    height?: number,
    connections: {
        inputs: any,
        outputs: any,
    },
    inputData: any,
    root?: boolean,
} };

var nval: Tree = {"cxy37HyUy2":{"x":-477.0291522868632,"y":-160.01942458662023,"type":"start","width":170,"connections":{"inputs":{},"outputs":{"flow":[{"nodeId":"kJsCleVS6e","portName":"callA"}]}},"inputData":{},"root":true,"id":"cxy37HyUy2"},"kJsCleVS6e":{"id":"kJsCleVS6e","x":-243,"y":-160,"type":"dialog","width":200,"connections":{"inputs":{"callA":[{"nodeId":"cxy37HyUy2","portName":"flow"}]},"outputs":{"flow":[{"nodeId":"6ic6_b1_sL","portName":"callA"}]}},"inputData":{"callA":{},"character":{"character":"billy"},"dialog":{"string":"Hello.\nGive me something."}}},"6ic6_b1_sL":{"id":"6ic6_b1_sL","x":131.5339616201457,"y":-40.78640243382131,"type":"givetake","width":200,"connections":{"inputs":{"callA":[{"nodeId":"kJsCleVS6e","portName":"flow"}]},"outputs":{"success":[{"nodeId":"mKS1VYx-Ql","portName":"callA"}],"failure":[{"nodeId":"AJ6NfZtCxg","portName":"callA"}]}},"inputData":{"callA":{},"givetake":{"givetake":"has"},"item":{"item":"apple"},"count":{"count":1}}},"mKS1VYx-Ql":{"id":"mKS1VYx-Ql","x":503.2608695652175,"y":33.69565217391305,"type":"dialog","width":200,"connections":{"inputs":{"callA":[{"nodeId":"6ic6_b1_sL","portName":"success"}]},"outputs":{"flow":[{"nodeId":"u5kypppR9i","portName":"callA"}]}},"inputData":{"callA":{},"character":{"character":"inherit"},"dialog":{"string":"I want that apple"}}},"AJ6NfZtCxg":{"id":"AJ6NfZtCxg","x":506.52173913043487,"y":307.608695652174,"type":"givetake","width":200,"connections":{"inputs":{"callA":[{"nodeId":"6ic6_b1_sL","portName":"failure"}]},"outputs":{"success":[{"nodeId":"NDvSqYzEcX","portName":"callA"}],"failure":[{"nodeId":"zftB1KK8Dw","portName":"callA"}]}},"inputData":{"callA":{},"givetake":{"givetake":"has"},"item":{"item":"orange"},"count":{"count":1}}},"NDvSqYzEcX":{"id":"NDvSqYzEcX","x":850.0000000000002,"y":408.6956521739131,"type":"dialog","width":200,"connections":{"inputs":{"callA":[{"nodeId":"AJ6NfZtCxg","portName":"success"}]},"outputs":{"flow":[{"nodeId":"u5kypppR9i","portName":"callB"}]}},"inputData":{"callA":{},"character":{"character":"inherit"},"dialog":{"string":"I want that orange!"}}},"zftB1KK8Dw":{"id":"zftB1KK8Dw","x":859.78257921007,"y":692.5121166087968,"type":"dialog","width":200,"connections":{"inputs":{"callA":[{"nodeId":"AJ6NfZtCxg","portName":"failure"}]},"outputs":{"flow":[{"nodeId":"u5kypppR9i","portName":"callC"}]}},"inputData":{"callA":{},"character":{"character":"inherit"},"dialog":{"string":"You don't have anything!"}}},"u5kypppR9i":{"id":"u5kypppR9i","x":1175.5845153216028,"y":212.37864077669923,"type":"dialog","width":200,"connections":{"inputs":{"callA":[{"nodeId":"mKS1VYx-Ql","portName":"flow"}],"callB":[{"nodeId":"NDvSqYzEcX","portName":"flow"}],"callC":[{"nodeId":"zftB1KK8Dw","portName":"flow"}]},"outputs":{}},"inputData":{"callA":{},"character":{"character":"inherit"},"dialog":{"string":"You suck!"}}}};

const Editor = observer(() => {
    const [tab, setTab] = React.useState(0);
    const [nodes, setNodes] = React.useState(nval);
    const [key, setKey] = React.useState("nodeeditor");
    const nodeEditor = React.useRef();
    const [active, setActive] = React.useState([]);
    if (store.gameLogicView) {
        return <ThemeProvider theme={theme}><Root>
            <TopBar />
            <GameLogicScreen />
        </Root></ThemeProvider>;
    } else if (store.browserSize[0] < 700) {
        return <ThemeProvider theme={theme}><Root>
            <TopBar />
            <ToolPanel />
            <WorkArea />
            <div id="flume" style={{width: '300px', height: '100%'}}>
                <NodeEditor />
            </div>
            {store.showPanels && <V>
                <H style={{maxHeight: '35px'}}>
                    <H style={{lineHeight: '35px', justifyContent: 'center'}} onClick={() => setTab(0)}>Objects</H>
                    <H style={{lineHeight: '35px', justifyContent: 'center'}} onClick={() => setTab(1)}>Properties</H>
                </H>
                {tab === 0 && <ObjectPanel />}
                {tab === 1 && <PropertyPanel />}
                <Timeline />
            </V>}
            <Picker />
            <div id="fps" style={{ position: 'absolute', bottom: '0px', right: '0px', color: theme.highlighted, background: 'rgba(0,0,0,0.5)' }} />
            <Cursor />
        </Root></ThemeProvider>;
    } else {
        return <ThemeProvider theme={theme}><Root>
            <div>{active.map((a) => `${a[0]}:${a[1].type}`).join(',')}</div>
            <TopBar />
            <H>
                <ToolPanel />
                <V>
                    <WorkArea />
                    <Timeline />
                </V>
                {store.showPanels && <V style={{maxWidth: '400px'}}>
                    <ObjectPanel />
                    <PropertyPanel />
                </V>}
            </H>
            <Picker />
            <div id="fps" style={{ position: 'absolute', bottom: '0px', right: '0px', color: theme.highlighted, background: 'rgba(0,0,0,0.5)' }} />
            <Cursor />
        </Root></ThemeProvider>;
    }
});

const Root = styled.div`
    position: fixed; top: env(safe-area-inset-top); left: env(safe-area-inset-left);
    right: env(safe-area-inset-right); bottom: env(safe-area-inset-bottom); display: flex;
    flex-direction: column;
    .Node_label__3MmhF {
        background: #316eca
    }
    .Node_wrapper__3SmT7, .Select_selectedWrapper__SUs4D, .TextInput_input__1QHwS {
        background: white;
    }
`;

const TopBar = observer(() => {
    return <Bar>
        <H />
        <BarButton active={store.gameLogicView} 
            onClick={() => store.gameLogicView = !store.gameLogicView}
        >
            <i className="material-icons">device_hub</i>
        </BarButton>
        <BarButton active={store.showPanels} 
            onClick={() => store.showPanels = !store.showPanels}
        >
            <i className="material-icons">list</i>
        </BarButton>
    </Bar>;
});

const H = styled.div`
    position: relative;
    display: flex; flex: 1;
    flex-direction: row;
    overflow: hidden;
`;

const V = styled.div`
    position: relative;
    display: flex; flex: 1;
    flex-direction: column;
    overflow: hidden
`;

const Bar = styled.div`
    position: relative; display: flex; flex-direction: row;
    height: 35px;
    background: ${theme.paneColor}; color: white;
    justify-content: center;
    align-items: center;
`;

const BarButton = styled.div<{active: boolean}>`
    cursor: pointer; width: 50px; height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${(e) => e.active ? e.theme.highlighted : ''};
`;

const Cursor = observer(() => {
    if (!store.showCursor) return null;
    const size = PointsTool.settings.size + 'px';
    const offset = PointsTool.settings.size/2;
    return <CursorStyle style={{
        top: store.mousePosition[1]-offset+'px', left: store.mousePosition[0]-offset+'px',
        width: size, height: size,
    }} />;
});

const CursorStyle = styled.div`
    position: absolute; border-radius: 500px; border: 1px solid black;
    pointer-events: none;
`;

document.body.addEventListener('keydown', (e) => {
    if (document.activeElement.tagName !== 'BODY') return;
    if (e.key === '[') {
        store.canvasRotation -= 45;
    }
    if (e.key === ']') {
        store.canvasRotation += 45;
    }
});

document.body.addEventListener('keyup', (e) => {
    console.log(e.key);
    if (document.activeElement.tagName !== 'BODY') return;
    if (e.key === 't') {
        document.getElementById('toolsearch').focus();
    }
    if (e.key === 'o') {
        document.getElementById('objectsearch').focus();
    }
    if (e.key === 'p') {
        document.getElementById('propertysearch').focus();
    }
    if (e.key === 'Backspace') {
        const o: any[] = scene.children.splice(scene.children.indexOf(state.object), 1);
        if (o && o[0] && o[0].type && objectTypes[o[0].type] && objectTypes[o[0].type].destroy) {
            objectTypes[o[0].type].destroy(o[0]);
        }
        state.object = null;
        store.object = null;
        rerender();
    }
    console.log(e);
    if (e.key === 'ArrowDown') {
        let pos = scene.children.indexOf(state.object);
        if (e.shiftKey) {
            if (pos < scene.children.length-1) scene.children.splice(pos+1, 0, scene.children.splice(pos, 1)[0]);
        } else {
            if (pos >= scene.children.length) pos = -1;
            state.object = scene.children[pos+1];
            if (state.object) store.object = state.object.id;
        }
        rerender();
    }
    if (e.key === 'ArrowUp') {
        let pos = scene.children.indexOf(state.object);
        if (e.shiftKey) {
            if (pos > 0) scene.children.splice(pos-1, 0, scene.children.splice(pos, 1)[0]);
        } else {
            if (pos <= 0) pos = scene.children.length;
            state.object = scene.children[pos-1];
            if (state.object) store.object = state.object.id;
        }
        rerender();
    }
    if (e.key === 'ArrowRight') {
        let pos = scene.children.indexOf(state.object);
        if (pos > 0) {
            scene.children[pos-1].children.push(scene.children.splice(pos)[0]);
        }
        rerender();
    }
    if (e.key === 'Escape') {
        state.object = null;
        store.object = null;
        rerender();
    }
    var tool = tools.find((t) => {
        return e.key === t.shortcut;
    });
    if (tool) {
        setTool(tool);
    }
})

export { Editor };
